import { PortalClassMediaBasic, PortalContentConfig } from '@nx-frontend/shared/types';
import { getClassNamePrefix } from './getTheme';

export function getContentGridClassNames({ cols }: PortalContentConfig): string[] {
  const colsClassNames = Object.keys(cols).map((key) => {
    const media = key as PortalClassMediaBasic;
    const mediaPrefix = getClassNamePrefix([media]);
    return `${mediaPrefix}grid-cols-${cols[media]}`;
  });

  return ['grid', ...colsClassNames];
}

export function getContentGapClassNames({ gap }: PortalContentConfig, gapTypes: string[] = ['gap']): string[] {
  return Object.keys(gap).reduce<string[]>((acc, key) => {
    const media = key as PortalClassMediaBasic;
    const mediaPrefix = getClassNamePrefix([media]);
    acc.push(...gapTypes.map((gapType) => `${mediaPrefix}${gapType}-${gap[media]}`));
    return acc;
  }, []);
}

export function getContentGridItemClassNames({ cols }: PortalContentConfig, colspan: number, rowspan: number) {
  if (colspan === 1 && rowspan === 1) {
    return [];
  }

  const classNames: string[] = Object.keys(cols).map((key) => {
    const media = key as PortalClassMediaBasic;
    let colspanCalc = Math.min(cols[media], colspan);
    if (media === PortalClassMediaBasic.MD && colspan === cols[PortalClassMediaBasic.LG] / 2) {
      colspanCalc = cols[media];
    }
    return `${getClassNamePrefix([media])}col-span-${colspanCalc}`;
  });

  if (rowspan > 1) {
    classNames.push(`row-span-${rowspan}`);
  }

  return classNames;
}
